// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2vfoZ","author":"Table_author__z7AbL","authorImage":"Table_authorImage__Xs5y9","unreadRow":"Table_unreadRow__2a66Z"};